import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "arrow-up-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4.8 9.07a.75.75 0 0 0 1.06 1.06L11 5v16.18a.75.75 0 0 0 1.5 0V5l5.14 5.14a.75.75 0 0 0 1.06-1.06L12.3 2.65a.75.75 0 0 0-1.08 0L4.8 9.07Z" }, null, -1)
  ])))
}
export default { render: render }